/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useState } from 'react'
import { Grid, Typography, Box } from '@mui/material'
import Cards from 'react-credit-cards-2'
import { InputButton, InputText, Loading } from '../../Simple'
import { CheckoutContext } from '../../../contexts/CheckoutContext'
import { AuthContext } from '../../../contexts/AuthContext'
import { IoChevronBack } from 'react-icons/io5'

import 'react-credit-cards-2/dist/es/styles-compiled.css'
import './stylesMSCC.css'

export default function NewCredCard({ handleMode, ClosedModal }) {
  const { sttAuthCtx } = useContext(AuthContext)
  const { sttCtxChkt, actionsChkt, loadCh } = useContext(CheckoutContext)

  const [inps, setInps] = useState({
    validade: '',
    focused: '',
    numCard: '',
    cpfInp: '',
    phone: '',
    nome: '',
    cvc: '',
  })

  function handlePhone(e) {
    let val = e.target.value.replace(/\D/g, '')
    val = val.replace(/^(\d{2})(\d)/g, '($1) $2')
    val = val.replace(/(\d)(\d{4})$/, '$1-$2')
    e.target.value = val
    setInps({ ...inps, phone: val })
  }

  function handleCpf(e) {
    let val = e.target.value.replace(/\D/g, '')
    val = val.replace(/(\d{3})(\d)/, '$1.$2')
    val = val.replace(/(\d{3})(\d)/, '$1.$2')
    val = val.replace(/(\d{3})(\d{2})$/, '$1-$2')
    e.target.value = val
    setInps({ ...inps, cpfInp: val })
  }

  function AdicionarCartao() {
    actionsChkt.AdicionarCartao(inps).then(res => {
      if (res) {
        handleMode()
      }
    })
  }
  function CriarContaComprador() {
    actionsChkt.CriarContaComprador(inps.cpfInp, inps.phone)
  }
  function VerificarContaComprador() {
    actionsChkt.ValidarContaComprador()
  }

  React.useEffect(() => {
    if (sttCtxChkt.isContaComprador === null) {
      VerificarContaComprador()
    }
  }, [])

  return (
    <div className='contain-captura-cc'>
      {!sttAuthCtx.isMobile && (
        <IoChevronBack
          size={30}
          className='btt-voltar-cc'
          onClick={() => {
            handleMode()
          }}
        />
      )}
      <Typography variant='h6' fontWeight='bold' align='left'>
        Adicionar um cartão
      </Typography>
      {loadCh.validarContaComprador ? (
        <div className='contain-loading' style={{ minHeight: '350px' }}>
          <Loading text={'Validando seus dados....'} />
        </div>
      ) : sttCtxChkt.isContaComprador === 'valid' ? (
        <>
          <Typography variant='body2' sx={{ mb: 2 }}>
            Preencha com as informações do seu cartão
          </Typography>
          {loadCh.cartaoCredito ? (
            <div className='contain-loading' style={{ minHeight: '350px' }}>
              <Loading text={'Carregando seus cartões....'} />
            </div>
          ) : (
            <>
              <Grid container spacing={2} sx={{ p: `${sttAuthCtx.isMobile ? 0 : 2}rem` }}>
                <Grid item xs>
                  <Box sx={{ width: '250px', height: '180px', justifyContent: 'center', alignItems: 'center' }}>
                    <Cards
                      cvc={inps.cvc}
                      expiry={inps.validade}
                      name={inps.nome}
                      number={inps.numCard}
                      focused={inps.focused}
                      placeholders={{
                        name: 'Nome do titular',
                        number: '**** **** **** ****',
                        expiry: 'MM/AA',
                        cvc: '***',
                      }}
                    />
                  </Box>
                </Grid>
                <Grid item xs={sttAuthCtx.isMobile ? 12 : 6} rowGap={2}>
                  <InputText
                    label={'Nome do titular'}
                    value={inps.nome}
                    onChange={e => {
                      if (inps.focused !== 'name') setInps(inps => ({ ...inps, nome: e.target.value, focused: 'name' }))
                      else setInps(inps => ({ ...inps, nome: e.target.value }))
                    }}
                    fullWidth={true}
                    type={'text'}
                    size={'small'}
                    placeholder={'Como está no cartão'}
                  />
                  <InputText
                    label={'Número do cartão'}
                    value={inps.numCard}
                    onChange={e => {
                      let val = e.target.value.replace(/[^0-9]/g, '')
                      if (val.length < 17) {
                        if (inps.focused !== 'number') setInps(inps => ({ ...inps, numCard: val, focused: 'number' }))
                        else setInps(inps => ({ ...inps, numCard: val }))
                      }
                    }}
                    fullWidth={true}
                    type={'text'}
                    size={'small'}
                    placeholder={'**** **** **** ****'}
                  />
                  <InputText
                    label={'Validade'}
                    value={inps.validade}
                    onChange={e => {
                      let val = e.target.value.replace(/[^0-9]/g, '')
                      if (val.length > 2) {
                        val = val.replace(/(\d{2})(\d{2})/, '$1/$2')
                      }
                      if (val.length <= 5) {
                        if (inps.focused !== 'expiry') setInps(inps => ({ ...inps, validade: val, focused: 'expiry' }))
                        else setInps(inps => ({ ...inps, validade: val }))
                      }
                    }}
                    fullWidth={true}
                    type={'text'}
                    size={'small'}
                    placeholder={'MM/AA'}
                  />
                  <InputText
                    label={'CVC'}
                    value={inps.cvc}
                    onChange={e => {
                      let val = e.target.value.replace(/[^0-9]/g, '')
                      if (val.length <= 3) {
                        if (inps.focused !== 'cvc') setInps(inps => ({ ...inps, cvc: val, focused: 'cvc' }))
                        else setInps(inps => ({ ...inps, cvc: val }))
                      }
                    }}
                    fullWidth={true}
                    type={'text'}
                    size={'small'}
                    placeholder={'***'}
                  />
                </Grid>
              </Grid>
              {/* <button
                  className='btt-modal-cc'
                  onClick={() => {
                    
                  }}
                >
                  Adicionar Cartão
                </button> */}
              <InputButton
                disabled={inps.nome === '' || inps.numCard === '' || inps.validade === '' || inps.cvc === ''}
                onClick={() => {
                  AdicionarCartao()
                }}
                variant='contained'
                sx={{ maxWidth: '350px', my: 1 }}
              >
                <Typography fontWeight='bold'>Adicionar</Typography>
              </InputButton>
            </>
          )}
        </>
      ) : (
        <div className='contain-complete-infos-add'>
          <h2>Antes de prosseguir, precisamos dos seguintes dados</h2>
          {loadCh.criarContaComprador ? (
            <div className='contain-loading' style={{ minHeight: '200px' }}>
              <Loading text={'Validando seus dados....'} />
            </div>
          ) : (
            <div className='contain-define-inputs-max'>
              <InputText
                className={'tw-mb-2'}
                label={'CPF do titular'}
                value={inps.cpfInp}
                onChange={handleCpf}
                fullWidth={true}
                type={'text'}
                size={'small'}
                placeholder={'CPF do titular'}
              />
              <InputText
                label={'Telefone de contato'}
                value={inps.phone}
                onChange={handlePhone}
                fullWidth={true}
                type={'text'}
                size={'small'}
                placeholder={'Telefone de contato'}
              />
              <div className='contain-btt-action-dados'>
                <button
                  title='Atualizar dados'
                  className='btt-action-dados'
                  onClick={() => {
                    //console.log("Atualizar dados!");
                    CriarContaComprador()
                  }}
                >
                  Criar
                </button>
                <button
                  className='btt-action-dados'
                  style={{ backgroundColor: 'gray', borderColor: 'gray' }}
                  onClick={() => {
                    ClosedModal()
                  }}
                >
                  Cancelar
                </button>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  )
}
